// 🔧 registration_generator.js
// ✅ Purpose: Generates registration numbers for LGV Seed Engine entries
// ✅ Features:
// - Creates industry-specific registration numbers
// - Keeps numbering logic separate from entry generation
// - Future-ready for configurable numbering formats
// - Fully block-commented for clarity and future devs

export const generateRegistrationNumber = ({
  industryKey = "car_show",
  index = 0,
} = {}) => {
  switch (industryKey) {
    case "car_show":
      return `CS-${String(index + 1).padStart(4, "0")}`;

    case "art_show":
      return `ART-${String(index + 1).padStart(4, "0")}`;

    case "pet_show":
      return `PET-${String(index + 1).padStart(4, "0")}`;

    case "sap_ai_agents_challenge":
      return `SAP-${String(index + 1).padStart(2, "0")}`;

    default:
      return `EV-${String(index + 1).padStart(4, "0")}`;
  }
};